<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title font-weight-bold" id="exampleModalLabel1">
      Agregar Canal/Producto
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="channelCreateForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-12">
          <mat-form-field style="width: 100%;">
            <mat-label>Canal/Producto</mat-label>
            <input
              type="text"
              formControlName="nombre"
              matInput
              placeholder="Ingrese el canal"
            />
            <mat-error
              *ngIf="channelCreateForm.get('nombre').hasError('required')"
              >El canal es <strong>requerida </strong></mat-error
            >
            <mat-error
              *ngIf="channelCreateForm.get('nombre').hasError('maxlength')"
              >El maximo de letras es <strong>30 </strong></mat-error
            >
            <mat-error
              *ngIf="channelCreateForm.get('nombre').hasError('pattern')"
              >Solo se admite <strong>letras </strong></mat-error
            >
          </mat-form-field>
        </div>
      </div>

      <button
        [disabled]="channelCreateForm.status != 'VALID'"
        type="submit"
        class="btn btn-info waves-effect float-right"
      >
        <i class="far fa-save"></i>
        Guardar
      </button>
    </form>
  </div>
</div>
